import { useRouter } from "next/navigation";
import { useMemo } from "react";

import Profile from "@/components/home/pages/Profile";
import { ProcessingFailedAlert } from "@/components/home/sections/ProcessingFailedAlert";
import type { EditPageSection } from "@/components/home/sections/ProfileSectionCard";
import { AppHead } from "@/components/shared/head/AppHead";
import { CommonModels } from "@/data/common/common.models";
import { useWorthCalcSse } from "@/hooks/sse/useWorthCalcSse";
import useUserProfileAndWorthData from "@/hooks/useUserProfileAndWorthData";
import { ProfileUtils } from "@/util/profile.utils";

export const MyProfilePage = () => {
  const { userProfile, worthData } = useUserProfileAndWorthData();
  useWorthCalcSse();

  const settingUpProfile = useMemo(
    () => ProfileUtils.getProfilePollingEnabled(userProfile?.status || undefined),
    [userProfile?.status],
  );

  const router = useRouter();

  const handleEditSection = (section: EditPageSection) => {
    router.push(`/profile/edit/${section}`);
  };

  const isProcessingFailed = userProfile?.status === CommonModels.ProfileStatusEnum.processing_failed;

  return (
    <div>
      <AppHead title={userProfile?.user.name || "User"} />
      {isProcessingFailed ? (
        <ProcessingFailedAlert />
      ) : (
        <Profile
          settingUpProfile={settingUpProfile}
          userProfile={userProfile}
          worthData={worthData as CommonModels.WorthNumbersDto}
          handleEditSection={handleEditSection}
        />
      )}
    </div>
  );
};
